/*
 * Date: 2025
 * Description: All reusable utils functions
 * Author: Philippe Leroux @ skitsc
 */

import { i_parts, i_vendor_entry } from "../interfaces/items.interface";
import { i_user } from "../interfaces/user.interface";
import { i_filter , i_promise } from "../interfaces/utility.interface";

const emptyPromise = (): i_promise => {
    const promise: i_promise = {
      message: "",
      type: "Failed",
      data: [],
    };
    return promise;
};
const delay = (ms : number) : Promise<void> => new Promise(res => setTimeout(res, ms));
const generateTimenow = () : number => {
    const timenow : number = Math.floor(Date.now() / 1000)
    return timenow
}
const encodeQueryData = (filter: i_filter): URLSearchParams => {
    const params = new URLSearchParams();
    Object.entries(filter).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
            if (Array.isArray(value)) {
                value.forEach((item) => params.append(`${key}[]`, item.toString()));
            } else {
                params.append(key, value.toString());
            }
        }
    });
    return params;
};
const formatTimestamp = (timestamp: number): string => {
    if (timestamp < 1e11) {
        timestamp *= 1000;
    }
    const date = new Date(timestamp);
    const now = new Date();
    const isToday = date.toDateString() === now.toDateString();
    const pad = (num: number) => num.toString().padStart(2, '0'); 
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());

    if (isToday) {
        return `Today ${hours}:${minutes}`;
    } else {
        const day = pad(date.getDate());
        const month = pad(date.getMonth() + 1);
        return `${day}-${month} ${hours}:${minutes}`;
    }
};
const formatYears = (years: number[]): string => {
    if (!years.length) return "-";
    years.sort((a, b) => a - b)
    var ranges: string[] = [];
    var start = years[0];
    var prev = start;
    for (let i = 1; i < years.length; i++) {
        if (years[i] !== prev + 1) {
            ranges.push(start === prev ? `${start}` : `${start} to ${prev}`);
            start = years[i];
        }
        prev = years[i];
    }
    ranges.push(start === prev ? `${start}` : `${start} to ${prev}`);
    return ranges.join(", ");
};
const setLocalKey = (key : string , input_value : any, time : number ) => {
    const now = new Date()
    const item = {
        value: input_value,
        expiry: now.getTime() + time,
    }
    localStorage.setItem(key, JSON.stringify(item))
  }
  
const getLocalKey = ( key : string ) => {
    const itemStr = localStorage.getItem(key)
    if(!itemStr) return null
    const item = JSON.parse(itemStr)
    const now = new Date()
    if (now.getTime() > item.expiry) {
        killStorage(key)
        return null
    }
    return item.value
}
const killStorage = ( key : string ) => {
    localStorage.removeItem(key)
}
const isToday = (date : Date) => {
    const today = new Date();
    if (today.toDateString() === date.toDateString()) return true;
    return false;
}

const isYear = (date : Date) => {
    const today = new Date();
    if (today.getFullYear() === date.getFullYear())return true;
    return false;
}
const pad = (value : number) => {
    if(value < 10) {
        return '0' + value;
    } else {
        return value;
    }
}
const timestampToDate = ( timestamp : number | string , type : 'short' | 'long' ) => {
    if(timestamp == null){
        return 0
    }else{
        if(Number(timestamp)){
            var timez : number = Number(timestamp)
            const UNIX_timestamp = new Date(timez * 1000)
            const is_today = isToday(UNIX_timestamp)
            const is_year = isYear(UNIX_timestamp)
            var time : string = '';
            var a : Date = new Date(UNIX_timestamp);
            var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
            var year : number = a.getFullYear();
            var month : string = months[a.getMonth()];
            var short_month : number = a.getMonth() + 1;
            var date : number = a.getDate();
            var hour : number = a.getHours();
            var min : string | number = pad(a.getMinutes());
            if(type !== undefined && type === 'short'){
                if(!is_today){
                    var str_year = String(year)
                time =  date + '/' + short_month + '/' + str_year.slice(2); 
                }else{
                    var moment = 'A.M'
                    if(hour > 12){
                        moment = 'P.M'
                        hour = hour - 12
                    }
                    time = hour + ':' + min + ' ' + moment;
                }
                return time
            }
  
            if(is_today === undefined || is_year === undefined){
                time = date + ' ' + month + ' ' + year + ' ' + hour + ':' + min;
                return time
            }
            if(is_today && is_year){
                time = "Today " +hour + ':' + min;
                return time
            }
                time = date + ' ' + month + ' ' + year + ' ' + hour + ':' + min;
            return time; 
        }
        }
     
  }
const renderStock = ( part : i_parts ) : string => {
    let lowestPrice : number | null = null;
    let available : null | string = null
    const vendors = part.vendors;
    for (const [vendorName, vendorArray] of Object.entries(vendors)) {
        if (!Array.isArray(vendorArray) || vendorArray.length === 0) continue;

        const vendor = vendorArray[0] as i_vendor_entry
        const rawPrice = vendor.price || '';
        const cleanedPrice = rawPrice.replace(/[^\d.,]/g, '').replace(',', '.');
        const price = parseFloat(cleanedPrice)
        const stock = vendor.stock?.trim().toLowerCase();
        const isStockAvailable = !!stock && stock !== 'n/a';

        if (price > 0) {
            if(lowestPrice === null){
                lowestPrice = price;
                available = isStockAvailable? 'Available' : 'Out of stock'
            }
            if(lowestPrice !== null && price < lowestPrice){
                lowestPrice = price
                available = isStockAvailable? 'Available' : 'Out of stock'
            }
            
        }
    }
    return available === null? ' Stock : N/A' :  " Stock : " + available
}
const renderPrice = ( part : i_parts ) : string => {
    var initialPrice = 'Price missing'
    let lowestPrice : number | null = null;
    var name : null | string = null
    let cat : null | string = null
    const vendors = part.vendors;
    for (const [vendorName, vendorArray] of Object.entries(vendors)) {
        if (!Array.isArray(vendorArray) || vendorArray.length === 0) continue;

        const vendor = vendorArray[0] as i_vendor_entry
        const rawPrice = vendor.price || '';
        const cleanedPrice = rawPrice.replace(/[^\d.,]/g, '').replace(',', '.');
        const price = parseFloat(cleanedPrice)
    

        if (price > 0) {
            if(lowestPrice === null){
                lowestPrice = price;
                name = vendorName;
            }
            if(lowestPrice !== null && price < lowestPrice){
                lowestPrice = price
                name = vendorName;
            }
            
        }
    }
    return lowestPrice === null? initialPrice :  name + " : " +lowestPrice.toFixed(2) + '$'
}

const renderTotal = ( parts : i_parts[] , user : i_user ) : string => {
     let total = 0
    if(user.type === 'user'){
        for(let i=0;i< parts.length;i++){
            total +=  Number(parts[i].price)
        }
    }
    if(user.type === 'admin'){
        var totalArr = []
        for(let i=0;i< parts.length;i++){
            var initialPrice = 'Price missing'
            let lowestPrice : number | null = null;
            const vendors = parts[i].vendors;
            for (const [vendorName, vendorArray] of Object.entries(vendors)) {
                    if (!Array.isArray(vendorArray) || vendorArray.length === 0) continue;
                    const vendor = vendorArray[0] as i_vendor_entry
                    const rawPrice = vendor.price || '';
                    const cleanedPrice = rawPrice.replace(/[^\d.,]/g, '').replace(',', '.');
                    const price = parseFloat(cleanedPrice)
                    if (price > 0) {
                        if(lowestPrice === null) lowestPrice = price;
                        if(lowestPrice !== null && price < lowestPrice) lowestPrice = price
                    }
            }
            if(lowestPrice !== null) totalArr.push(lowestPrice)
            
        }
        total = totalArr.reduce((a, b) => a + b, 0)
    }
    return total.toFixed(2).toString()
}
const formatDateTimeLocal = (date: Date) => {
    const pad = (n: number) => n.toString().padStart(2, "0");
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    return `${year}-${month}-${day}T${hours}:${minutes}`;
};
export { emptyPromise , delay , encodeQueryData , formatTimestamp , formatYears , getLocalKey , setLocalKey , killStorage , timestampToDate , renderPrice  , renderStock , renderTotal , generateTimenow , formatDateTimeLocal }